export class OptionItemModel {
  /**Идентификатор */
  Id: string | number;
  /**Иконка */
  Icon?: string;
  /**Название */
  Name: string;
  /**Цвет */
  Color?: string;
  /**Картинка */
  Image?: string;
  /**Ширина элемента */
  Width?: number;
  /**Тип глобального статусы */
  GlobalStatusType?: number;
  /**Поиск */
  searchName?: string;

  constructor(obj?: Partial<OptionItemModel>) {
    Object.assign(this, obj);
  }
}
